// Colors for CSS
export const COLORS = {
  // Dark Blue:
  blue: "#00519C",
  // Red
  red: "#EA0000",
  //Cream (background)
  cream: "#ffedd3",
  // cream: "#ffe4bc",
};
